import { ListCache } from "../ListCache";
import { TranslatedCollection } from "~/translations/translatedCollection/TranslatedCollection";

export const translatedCollectionCache = new ListCache<TranslatedCollection>();
